export const LiveScheduleAccessRoutes = [
    {
        "url": "/live-schedule-access",
        "name": "appLayout.harriSH.live-schedule-access",
        "type": "frontend",
        "loginRequired": true,
        "component": "liveScheduleContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["live-schedule-access"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/live-schedule-access/live-schedule-access.downgrade.module");
                }
            },
        ],
        "onEnter": ['brandServices', 'hUser', '$state', async (brandServices, hUser, $state) => {
                brandServices.checkAll(hUser.getEntryMode()['brand_id'], [brandServices.SERVICES.TEAM_SCHEDULING], true)
                    .then((services) => {
                    if (!services[brandServices.SERVICES.TEAM_SCHEDULING]) {
                        if (hUser.isTopLevelContext()) {
                            Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                        }
                        else {
                            $state.go("appLayout.harriSH.dashboard");
                        }
                    }
                });
            }],
    }
];
export const LiveScheduleAccessTLRoutes = [
    {
        "url": "/tl-live-schedule-access",
        "name": "appLayout.schedule.live-schedule-access",
        "showGlobalSearch": true,
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "body": {
                component: "liveScheduleContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["live-schedule-access"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/live-schedule-access/live-schedule-access.downgrade.module");
                }
            },
        ],
        "onEnter": ['brandServices', 'hUser', '$state', async (brandServices, hUser, $state) => {
                brandServices.checkAll(hUser.getEntryMode()['brand_id'], [brandServices.SERVICES.TEAM_SCHEDULING], true)
                    .then((services) => {
                    if (!services[brandServices.SERVICES.TEAM_SCHEDULING]) {
                        if (hUser.isTopLevelContext()) {
                            Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                        }
                        else {
                            $state.go("appLayout.harriSH.dashboard");
                        }
                    }
                });
            }],
    }
];
//# sourceMappingURL=live-schedule-access.routes.js.map